export default {"src":"/_next/static/media/cloud.a888adb2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};